const customFieldSubTypes = {
    a2KeyLPart1Mc: 'A2 Key L Part 1 MC',
    b1PrelimLPart1Mc: 'B1 Prelim L Part 1 MC',
    b1PrelimRPart2: 'B1 Prelim R Part 2',
    b1PrelimRPart4: 'B1 Prelim R Part 4',
    b2FirstRuePart6: 'B2 First RUE Part 6',
    c1AdvancedRue7: 'C1 Advanced RUE 7',
    c2ProficiencyRuePart6: 'C2 Proficiency RUE Part 6',
};

export default customFieldSubTypes;
